

import React from "react";

function Updates() {
  return (
    <main className="page">
      <section className="content-page">
        <div className="content-card">
          <div className="card-header">
            <span className="page-badge">ASDRY UPDATES</span>
            <h1 className="page-title">Building ASDRY in public</h1>
          </div>

          <div className="card-body">
            <p>
              This page tracks what is changing in ASDRY Beta, what feedback is
              being worked on, and what has been improved as the app develops.
            </p>

            <p>
              The aim is to be open about the process: what users are finding
              useful, what needs fixing, and how real-world testing is shaping the
              product.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">21 June 2026 — Beta and future plans wording updated</h2>
            <p>
              The app wording has been updated so it no longer presents Pro or
              Business plans as finished products. ASDRY is currently focused on
              improving the Free Beta report through testing and feedback.
            </p>
            <p>
              Pro and Business options are still in development and may change as
              testing continues.
            </p>
            <p>
              <strong>Status:</strong> Completed.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">20 June 2026 — Privacy and consent flow tested</h2>
            <p>
              The signup, privacy notice acceptance, account preferences, data
              export, and account deletion request flow have been tested with a new
              account.
            </p>
            <p>
              Privacy notice versioning is now being recorded correctly in the
              ASDRY database.
            </p>
            <p>
              <strong>Status:</strong> Completed.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">June 2026 — Free activity report testing</h2>
            <p>
              ASDRY Beta is being tested across everyday activities including
              walking, commuting, running, cycling, dog walking, gardening, and
              hanging washing outdoors.
            </p>
            <p>
              Feedback from these checks is being used to improve how the reports
              describe weather impact, activity preparation, surface conditions,
              wind, rain, and temperature.
            </p>
            <p>
              <strong>Status:</strong> Ongoing.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">Parkrun field testing</h2>
            <p>
              ASDRY has also been tested through Parkrun-style field reports. These
              tests help compare forecast-based guidance against real course
              conditions, runner experience, volunteer exposure, and what was
              actually noticed on the day.
            </p>
            <p>
              Future Parkrun testing is expected to become more runner-focused,
              with more attention on footwear, surface conditions, clothing,
              comfort, effort, and whether the report matched the real experience.
            </p>
            <p>
              <strong>Status:</strong> Ongoing.
            </p>

            <hr className="content-divider" />

            <h2 className="content-subtitle">How feedback may appear here</h2>
            <p>
              When users share useful feedback, future updates may explain what was
              reported, what was reviewed, and what changed as a result.
            </p>

            <p>
              Example:
            </p>

            <blockquote>
              A runner reports that a wet run felt more affected by rain and surface
              conditions than by temperature. ASDRY reviews the report wording and
              adjusts the running guidance so similar future reports better reflect
              that experience.
            </blockquote>

            <p>
              This keeps ASDRY honest, useful, and connected to real people using
              the app.
            </p>

            <div className="cta-row">
              <a href="https://asdry.app" className="home-primary">
                Try ASDRY Beta →
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Updates;